import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/leaseContract/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/leaseContract/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/leaseContract/update',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/leaseContract/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/leaseContract/delete',
    method: 'post',
    data: data
  });
} // 合同列表合同的状态

export function fetchConstractState(data) {
  return request({
    url: '/pmsservice/api/leaseContract/getContractNumByContractType',
    method: 'post',
    data: data
  });
}
export function fetchChargeBill(data) {
  return request({
    url: '/pmsservice/api/leaseContract/getContractChargeBill',
    method: 'post',
    data: data
  });
} // 变更合同状态

export function fetchChangeChargeStatus(data) {
  return request({
    url: '/pmsservice/api/leaseContract/updateContractType',
    method: 'post',
    data: data
  });
} // 费用详情

export function fetchChargeDetail(data) {
  return request({
    url: '/pmsservice/api/leaseContract/getContractChargeDetail',
    method: 'post',
    data: data
  });
} // 合同详情-租用房间

export function fetchContractResource(data) {
  return request({
    url: '/pmsservice/api/leaseContract/getContractResource',
    method: 'post',
    data: data
  });
} // 合同详情-收费标准

export function fetchContractChargeStandard(data) {
  return request({
    url: '/pmsservice/api/leaseContract/getContractChargeStandard',
    method: 'post',
    data: data
  });
} // 合同详情-账单明细

export function fetchContractChargeBillDetail(data) {
  return request({
    url: '/pmsservice/api/leaseContract/getContractChargeBillDetail',
    method: 'post',
    data: data
  });
} // 检查合同名称和编号的唯一性

export function fetchCheckContractUnique(data) {
  return request({
    url: '/pmsservice/api/leaseContract/checkContractUnique',
    method: 'post',
    data: data
  });
} // 统计一个月合同到期预警的数量

export function fetchContractExpirationWarningNum(data) {
  return request({
    url: '/pmsservice/api/leaseContract/countContractExpirationWarningNum',
    method: 'post',
    data: data
  });
}
export function fetchContractExpirationWarning(data) {
  return request({
    url: '/pmsservice/api/leaseContract/getContractExpirationWarning',
    method: 'post',
    data: data
  });
}